import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { ReactComponent as IconCircle } from 'svg/check-circle-regular.svg';
import cx from 'classnames';

import s from './styles.module.scss';

const ResourceItem = ({ className, children, read, subField, url }) => (
  <NavLink
    activeClassName={s.resourceItemActive}
    className={cx(s.resourceItem, className)}
    to={`/resources/${url}`}
  >
    <div className={cx(s.title, { [s.subField]: subField })}>{children}</div>
    {read && (
      <div className={s.readIcon}>
        <IconCircle />
      </div>
    )}
  </NavLink>
);

ResourceItem.defaultProps = {
  className: null,
  read: false,
  subField: false,
};

ResourceItem.propTypes = {
  children: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  className: PropTypes.string,
  read: PropTypes.bool,
  subField: PropTypes.bool,
};

export default ResourceItem;
